import { SavedReportSettingsConfig } from '~/data/reportSettings';

export type IncludedSavedSettings = {
  reportSelection: boolean;
  columnVisibility: boolean;
  columnSorting: boolean;
  columnFiltering: boolean;
};

export const getIncludedSavedSettings = <P>(
  settingsConfig?: SavedReportSettingsConfig<P>,
): IncludedSavedSettings => {
  return {
    reportSelection: typeof settingsConfig?.reportSelection !== 'undefined',
    columnVisibility: typeof settingsConfig?.columnVisibility !== 'undefined',
    columnSorting: typeof settingsConfig?.columnSorting !== 'undefined',
    columnFiltering: typeof settingsConfig?.columnFiltering !== 'undefined',
  };
};

export const getInitialFormSavedSettings = <P>(
  isEdit: boolean,
  settingsConfig?: SavedReportSettingsConfig<P>,
): IncludedSavedSettings => {
  if (isEdit) {
    return getIncludedSavedSettings(settingsConfig);
  }

  return {
    reportSelection: true,
    columnVisibility: true,
    columnSorting: true,
    columnFiltering: true,
  };
};
